<template>
    <div id="Sections">

        

        <HeaderSec />
      
   
        <div v-if="historyOption =='Default'">
            <Default/>

        </div>
       
        <div v-else-if="historyOption =='Dashboard'">
                 <Default/>
        </div> 

        <div v-else-if="historyOption =='Servicios'">
                 <Servicios/>
        </div>  
        
        <div v-else-if="historyOption =='MiPerfil'">
                 <MiPerfil/>
        </div>  
           <div v-else-if="historyOption =='PDFcreate'">
            <PDFcreate />
        </div>
         <div v-else-if="historyOption =='PDFenglishcreate'" >
            <PDFcreate_eng/>
        </div>
       
       
    
        
        <div v-else>
              <Default/>      
        </div>

       
    </div>
</template>
<script>

import {mapActions} from 'vuex';
import HeaderSec from './HeaderSecSuc.vue';
import Default  from '../views/Default/DefaulSuc.vue'
import MiPerfil from '../views/clientes/miPerfilSuc.vue'
import Servicios from '../views/clientes/serviciosSuc.vue'
import PDFcreate from './PDFcreate.vue'
import PDFcreate_eng from './PDFcreate_eng.vue'

export default {
  name: 'Sections',
  components:{
      HeaderSec,
      Default,
      MiPerfil,
      PDFcreate,
      Servicios,
      PDFcreate_eng
  },
 
   data(){
       return{
           search_value:'',
           status:'',
           message:'',
           option:'Default',
       }
   },
    computed:{
        historyOption(){
            return this.$store.getters["main/getHistoryOption"]
        },
    },
   created(){
        let option = localStorage.getItem('nav')
        if(option != undefined && option != null && option != ''){
            this.option = option
            this.setHistoryOptionMain(option)
        }
      
   },
   methods:{
       ...mapActions('main', ['setHistoryOptionMain']),
        ...mapActions('main', ['getHistoryOption']),
   }

   
    
 
}
</script>
<style scoped>
   
   #Sections{
    background: var(--color-5);
     min-height: 59.25VW;
     width: 78.17708333333333VW;
   }

   .proximamente p{
       color: var(--color-1);
       font-weight: 700;
       font-size: 5vw;
       margin-top: 11.5vw;
       margin-left: 15vw;
   }


  



</style>
